const checkout = {
	state: () => ({}),
	mutations: {},
	actions: {},
	getters: {}
}

export default checkout;